import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-73c6a4eb"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "c-date-header1 flex align-center"
};
var _hoisted_2 = {
  key: 1,
  class: "dateSelect flex align-center mr-auto"
};
var _hoisted_3 = {
  key: 0,
  class: "label"
};
var _hoisted_4 = {
  key: 3,
  class: "daterangeSelect flex align-center",
  style: {
    "width": "100%"
  }
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "至", -1);
});
var _hoisted_6 = {
  class: "picker-wrapper"
};
var _hoisted_7 = {
  class: "picker-header"
};
var _hoisted_8 = {
  class: "picker-row"
};
var _hoisted_9 = {
  class: "picker-wrapper"
};
var _hoisted_10 = {
  class: "picker-header"
};
var _hoisted_11 = {
  class: "picker-row"
};
var _hoisted_12 = {
  key: 1,
  class: "mr-auto"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_date_select = _resolveComponent("c-date-select");
  var _component_el_date_picker = _resolveComponent("el-date-picker");
  var _component_van_date_picker = _resolveComponent("van-date-picker");
  var _component_van_time_picker = _resolveComponent("van-time-picker");
  var _component_van_popup = _resolveComponent("van-popup");
  var _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.showDate ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.type === 0 ? (_openBlock(), _createBlock(_component_c_date_select, {
    key: 0,
    class: "my-2 flex-1",
    onConfirmDate: _ctx.confirmDateDay
  }, null, 8, ["onConfirmDate"])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_ctx.type !== 3 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1)) : _createCommentVNode("", true), _ctx.type === 1 ? (_openBlock(), _createBlock(_component_el_date_picker, {
    key: 1,
    editable: false,
    clearable: false,
    modelValue: _ctx.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.date = $event;
    }),
    type: "week",
    format: "gggg年ww周",
    placeholder: "请选择",
    disabledDate: _ctx.disabledDateApi,
    onChange: _ctx.confirmDate
  }, null, 8, ["modelValue", "disabledDate", "onChange"])) : _createCommentVNode("", true), _ctx.type === 2 ? (_openBlock(), _createBlock(_component_el_date_picker, {
    key: 2,
    editable: false,
    clearable: false,
    modelValue: _ctx.date,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.date = $event;
    }),
    type: "month",
    placeholder: "请选择",
    disabledDate: _ctx.disabledDateApi,
    onChange: _ctx.confirmDate
  }, null, 8, ["modelValue", "disabledDate", "onChange"])) : _createCommentVNode("", true), _ctx.type === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
    class: "custom-field",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    function () {
      return _ctx.openStartPicker && _ctx.openStartPicker.apply(_ctx, arguments);
    })
  }, [_createElementVNode("span", {
    class: _normalizeClass(['text', {
      placeholder: !_ctx.startTimeText
    }])
  }, _toDisplayString(_ctx.startTimeText || '请选择开始时间'), 3)]), _hoisted_5, _createElementVNode("div", {
    class: "custom-field",
    onClick: _cache[3] || (_cache[3] =
    //@ts-ignore
    function () {
      return _ctx.openEndPicker && _ctx.openEndPicker.apply(_ctx, arguments);
    })
  }, [_createElementVNode("span", {
    class: _normalizeClass(['text', {
      placeholder: !_ctx.endTimeText
    }])
  }, _toDisplayString(_ctx.endTimeText || '请选择结束时间'), 3)])])) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
    show: _ctx.showStartPicker,
    "onUpdate:show": _cache[8] || (_cache[8] = function ($event) {
      return _ctx.showStartPicker = $event;
    }),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return _ctx.showStartPicker = false;
        })
      }, "取消"), _createElementVNode("span", {
        onClick: _cache[5] || (_cache[5] =
        //@ts-ignore
        function () {
          return _ctx.onStartConfirm && _ctx.onStartConfirm.apply(_ctx, arguments);
        })
      }, "确定")]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_date_picker, {
        modelValue: _ctx.startDateArr,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return _ctx.startDateArr = $event;
        }),
        "min-date": _ctx.startMinDate,
        "max-date": _ctx.startMaxDate,
        "show-toolbar": false
      }, null, 8, ["modelValue", "min-date", "max-date"]), _createVNode(_component_van_time_picker, {
        modelValue: _ctx.startTimeArr,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
          return _ctx.startTimeArr = $event;
        }),
        "show-toolbar": false
      }, null, 8, ["modelValue"])])])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: _ctx.showEndPicker,
    "onUpdate:show": _cache[13] || (_cache[13] = function ($event) {
      return _ctx.showEndPicker = $event;
    }),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", {
        onClick: _cache[9] || (_cache[9] = function ($event) {
          return _ctx.showEndPicker = false;
        })
      }, "取消"), _createElementVNode("span", {
        onClick: _cache[10] || (_cache[10] =
        //@ts-ignore
        function () {
          return _ctx.onEndConfirm && _ctx.onEndConfirm.apply(_ctx, arguments);
        })
      }, "确定")]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_date_picker, {
        modelValue: _ctx.endDateArr,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
          return _ctx.endDateArr = $event;
        }),
        "min-date": _ctx.endMinDate,
        "max-date": _ctx.endMaxDate,
        "show-toolbar": false
      }, null, 8, ["modelValue", "min-date", "max-date"]), _createVNode(_component_van_time_picker, {
        modelValue: _ctx.endTimeArr,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
          return _ctx.endTimeArr = $event;
        }),
        "show-toolbar": false
      }, null, 8, ["modelValue"])])])];
    }),
    _: 1
  }, 8, ["show"])]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_12)), _ctx.type < 3 && _ctx.showBtn || _ctx.forceShow ? (_openBlock(), _createBlock(_component_van_button, {
    key: 2,
    type: "primary",
    size: "small",
    onClick: _ctx.switchBtnClick
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.btnText), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]);
}